var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg403OopsImage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 863,
    height: 463,
    viewBox: "0 0 863 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M732.79 238.767C686.929 200.955 625.51 200.575 567.75 162.172C496.235 114.624 420.903 28.6326 318.718 64.8965C262.107 84.9852 246.645 155.859 244.411 167.169C243.969 169.405 243.507 171.624 242.969 173.838C238.459 192.375 231.109 253.568 160.421 304.73C79.3697 363.395 103.811 436.041 131.183 461.542H691.554C806.368 373.285 791.12 286.858 732.79 238.767Z",
    fill: "#C6D8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.793 86.3969C178.383 69.9137 165.163 57.6892 149.001 54.4372C128.43 50.2986 94.9362 52.824 58.72 93.1763C-0.544058 159.21 47.7969 203.993 87.0591 196.423C122.314 189.626 192.593 138.612 181.793 86.3969Z",
    fill: "#C6D8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M854.859 340.282H800.551C795.276 340.282 791 336.006 791 330.73V280.241C791 276.242 794.243 273 798.24 273H854.859C858.857 273 862.099 276.242 862.099 280.241V333.041C862.099 337.039 858.857 340.282 854.859 340.282Z",
    fill: "#678BD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M843.78 305.14H835.555C835.51 302.666 835.188 300.192 834.577 297.719H841.561C842.823 299.933 843.608 302.453 843.78 305.14ZM841.561 314.797H834.355C835.007 312.324 835.4 309.851 835.52 307.377H843.78C843.61 310.064 842.823 312.583 841.561 314.797ZM831.335 322.852C832.274 320.913 833.063 318.974 833.695 317.036H840.04C837.839 319.787 834.813 321.852 831.335 322.852ZM826.553 323.523C825.786 323.523 825.03 323.473 824.29 323.376C823.235 321.263 822.338 319.149 821.614 317.036H831.49C830.767 319.149 829.869 321.263 828.814 323.376C828.075 323.473 827.319 323.523 826.553 323.523ZM813.064 317.036H819.41C820.044 318.974 820.831 320.913 821.769 322.852C818.293 321.852 815.266 319.787 813.064 317.036ZM811.544 314.797C810.282 312.583 809.495 310.064 809.324 307.377H817.584C817.705 309.85 818.098 312.324 818.75 314.797H811.544ZM811.544 297.719H818.529C817.917 300.192 817.595 302.666 817.55 305.14H809.324C809.495 302.453 810.282 299.933 811.544 297.719ZM821.534 289.735C820.563 291.65 819.774 293.567 819.163 295.481H813.064C815.216 292.792 818.156 290.759 821.534 289.735ZM826.553 288.993C827.473 288.993 828.375 289.064 829.256 289.204C830.429 291.295 831.348 293.388 832.031 295.481H821.074C821.757 293.388 822.676 291.295 823.849 289.204C824.729 289.064 825.632 288.993 826.553 288.993ZM833.505 307.377C833.335 309.85 832.889 312.324 832.19 314.797H820.915C820.216 312.324 819.768 309.851 819.6 307.377H833.505ZM819.525 305.14C819.527 302.666 819.82 300.192 820.432 297.719H832.674C833.285 300.192 833.577 302.666 833.579 305.14H819.525ZM840.04 295.481H833.942C833.33 293.567 832.543 291.65 831.572 289.735C834.949 290.76 837.889 292.792 840.04 295.481ZM813.019 292.726C805.587 300.158 805.588 312.358 813.019 319.791C820.452 327.223 832.652 327.223 840.085 319.791C847.518 312.359 847.518 300.158 840.085 292.726C832.652 285.293 820.452 285.293 813.019 292.726Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.042 83.9146H154.715C148.791 83.9146 143.99 79.1122 143.99 73.189V40.4956C143.99 34.5724 148.791 29.7712 154.715 29.7712H190.042C195.966 29.7712 200.767 34.5724 200.767 40.4956V73.189C200.767 79.1122 195.966 83.9146 190.042 83.9146Z",
    fill: "#678BD5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.668 48.5369L181.09 65.1484",
    stroke: "white",
    strokeWidth: 4.07909,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.09 48.5369L163.668 65.1484",
    stroke: "white",
    strokeWidth: 4.07909,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46125 306.593C8.09451 304.272 5.91464 302.686 3.5927 303.053C1.27075 303.42 -0.31399 305.599 0.0527434 307.923C0.419593 310.244 2.59982 311.828 4.92141 311.462C7.24382 311.095 8.82856 308.914 8.46125 306.593Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.462 68.592C253.094 66.2696 250.915 64.6856 248.593 65.053C246.27 65.4193 244.686 67.5982 245.053 69.9206C245.42 72.243 247.6 73.8282 249.921 73.4608C252.244 73.0933 253.828 70.9144 253.462 68.592Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.988 394.287H84.0944C82.7252 394.287 81.6152 393.177 81.6152 391.807C81.6152 390.438 82.7252 389.329 84.0944 389.329H128.988C130.357 389.329 131.467 390.438 131.467 391.807C131.467 393.177 130.357 394.287 128.988 394.287Z",
    fill: "#678BD5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M842.793 13.8223H835.481C833.558 13.8223 832 12.2651 832 10.3428V3.47815C832 1.557 833.558 -0.00022316 835.481 -0.00022316H842.793C844.714 -0.00022316 846.273 1.557 846.273 3.47815V10.3428C846.273 12.2651 844.714 13.8223 842.793 13.8223Z",
    fill: "#01C324"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.793 43.8223H20.4798C18.5579 43.8223 17 42.265 17 40.3427V33.4782C17 31.557 18.5579 29.9998 20.4798 29.9998H27.793C29.7144 29.9998 31.2723 31.557 31.2723 33.4782V40.3427C31.2723 42.265 29.7144 43.8223 27.793 43.8223Z",
    fill: "#678BD5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M809.409 124.813C809.409 129.129 805.959 132.626 801.704 132.626C797.449 132.626 794 129.129 794 124.813C794 120.498 797.449 117 801.704 117C805.959 117 809.409 120.498 809.409 124.813Z",
    stroke: "white",
    strokeWidth: 1.29017,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9071 217.065C98.9071 221.52 95.3462 225.131 90.9537 225.131C86.5608 225.131 83 221.52 83 217.065C83 212.61 86.5608 209 90.9537 209C95.3462 209 98.9071 212.61 98.9071 217.065Z",
    stroke: "white",
    strokeWidth: 1.29017,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M591 30H653.062",
    stroke: "white",
    strokeWidth: 1.29017,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63 127.827H103.635",
    stroke: "white",
    strokeWidth: 1.29017,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M752 389H791.174",
    stroke: "white",
    strokeWidth: 1.29017,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M675.519 403.705H190.434C184.174 403.705 179.102 398.632 179.102 392.373V106.457C179.102 100.198 184.174 95.1242 190.434 95.1242H675.519C681.778 95.1242 686.852 100.198 686.852 106.457V392.373C686.852 398.632 681.778 403.705 675.519 403.705Z",
    fill: "#678BD5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M674.538 392.921H191.412V105.908H674.538V392.921Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M386.137 394.048L377.125 452.194H493.342L484.804 394.048H386.137Z",
    fill: "#678BD5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M504.531 461.542H365.934V452.195H504.531V461.542Z",
    fill: "#013DB9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M384.64 403.705H486.222L487.546 412.724L384.068 407.392L384.64 403.705Z",
    fill: "#013DB9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M633.541 349.43H476.395C472.964 349.43 470.182 346.648 470.182 343.216V156.76C470.182 153.328 472.964 150.546 476.395 150.546H633.541C636.973 150.546 639.756 153.328 639.756 156.76V343.216C639.756 346.648 636.973 349.43 633.541 349.43Z",
    fill: "#DBE6F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M580.916 212.852V197.598C580.916 185.387 571.016 175.486 558.803 175.486C550.203 175.486 542.749 180.395 539.094 187.564",
    stroke: "#FFFFFC",
    strokeWidth: 5.58287,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M565.505 278.457H550.871C535.025 278.457 522.182 265.612 522.182 249.768V211.567C522.182 208.737 524.475 206.444 527.304 206.444H589.072C591.902 206.444 594.195 208.737 594.195 211.567V249.768C594.195 265.612 581.35 278.457 565.505 278.457Z",
    fill: "#EBAE5C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M566.373 232.494C566.373 237.137 562.609 240.902 557.964 240.902C553.322 240.902 549.557 237.137 549.557 232.494C549.557 227.85 553.322 224.085 557.964 224.085C562.609 224.085 566.373 227.85 566.373 232.494Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M555.476 238.327L548.691 257.801H567.686L560.425 238.327H555.476Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M599.635 322.601H513.091C506.598 322.601 501.336 317.338 501.336 310.846C501.336 304.353 506.598 299.091 513.091 299.091H599.635C606.127 299.091 611.39 304.353 611.39 310.846C611.39 317.338 606.127 322.601 599.635 322.601Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M533.792 306.707L531.004 310.375V310.435L535.436 309.848V311.842L531.004 311.315V311.374L533.821 314.895L531.971 315.954L530.21 311.842H530.153L528.246 315.982L526.572 314.926L529.36 311.344V311.287L525.016 311.842V309.848L529.332 310.404V310.347L526.572 306.765L528.362 305.739L530.182 309.818H530.24L532.031 305.709L533.792 306.707Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M552.362 306.707L549.574 310.375V310.435L554.007 309.848V311.842L549.574 311.315V311.374L552.392 314.895L550.543 315.954L548.78 311.842H548.723L546.816 315.982L545.142 314.926L547.93 311.344V311.287L543.586 311.842V309.848L547.902 310.404V310.347L545.142 306.765L546.932 305.739L548.752 309.818H548.812L550.601 305.709L552.362 306.707Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M570.931 306.707L568.144 310.375V310.435L572.576 309.848V311.842L568.144 311.315V311.374L570.962 314.895L569.112 315.954L567.349 311.842H567.292L565.385 315.982L563.711 314.926L566.5 311.344V311.287L562.156 311.842V309.848L566.47 310.404V310.347L563.711 306.765L565.502 305.739L567.321 309.818H567.381L569.17 305.709L570.931 306.707Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M589.502 306.707L586.714 310.375V310.435L591.147 309.848V311.842L586.714 311.315V311.374L589.532 314.895L587.682 315.954L585.921 311.842H585.861L583.955 315.982L582.281 314.926L585.07 311.344V311.287L580.727 311.842V309.848L585.041 310.404V310.347L582.281 306.765L584.072 305.739L585.892 309.818H585.951L587.74 305.709L589.502 306.707Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M498 82.4991C498 113.705 472.703 139 441.499 139C410.297 139 385 113.705 385 82.4991C385 51.295 410.297 26 441.499 26C472.703 26 498 51.295 498 82.4991Z",
    fill: "#F9B4B4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M448.164 55L447.847 90.7517H436.074C436.074 77.2291 435.836 68.6072 435.836 55H448.164ZM449 103.826C449 113.391 435 113.391 435 103.826C435 94.1774 449 94.1774 449 103.826Z",
    fill: "#EA2222"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M443.658 270.111H225.585C223.384 270.111 221.598 268.326 221.598 266.124V152.361C221.598 150.158 223.384 148.374 225.585 148.374H443.658C445.86 148.374 447.645 150.158 447.645 152.361V266.124C447.645 268.326 445.86 270.111 443.658 270.111Z",
    fill: "#DBE6F1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M376.732 200.297L335.183 167.683L292.408 200.297H376.732Z",
    fill: "#1F0C07"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M293.635 244.472H376.733V200.297H293.635V244.472Z",
    fill: "#CC8938"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M362.947 166.434H306.332V240.034H362.947V166.434Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M292.408 200.298V254.06H355.975L304.577 203.41C302.553 201.416 299.826 200.298 296.983 200.298H292.408Z",
    fill: "#EDBA76"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M376.731 200.298V254.06H313.164L364.563 203.41C366.587 201.416 369.314 200.298 372.155 200.298H376.731Z",
    fill: "#EBAE5C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M315.484 177.056H354.883",
    stroke: "#DBE6F1",
    strokeWidth: 1.38044,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M315.484 185.603H354.883",
    stroke: "#DBE6F1",
    strokeWidth: 1.38044,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M315.484 194.149H354.883",
    stroke: "#DBE6F1",
    strokeWidth: 1.38044,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M315.484 202.696H333.681",
    stroke: "#DBE6F1",
    strokeWidth: 1.38044,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M441.515 348.871H227.788C224.369 348.871 221.598 346.1 221.598 342.682V294.812C221.598 291.393 224.369 288.621 227.788 288.621H441.515C444.934 288.621 447.706 291.393 447.706 294.812V342.682C447.706 346.1 444.934 348.871 441.515 348.871Z",
    fill: "#DBE6F1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M295.654 332.27C288.526 332.27 282.748 326.493 282.748 319.366C282.748 312.237 288.526 306.46 295.654 306.46C302.781 306.46 308.559 312.237 308.559 319.366C308.559 326.493 302.781 332.27 295.654 332.27Z",
    fill: "#678BD5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M322.182 319.84H394.825",
    stroke: "white",
    strokeWidth: 1.91281,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M322.182 310.342H367.901",
    stroke: "white",
    strokeWidth: 1.91281,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M322.182 329.521H336.003",
    stroke: "white",
    strokeWidth: 1.91281,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2773 461.542H809.338",
    stroke: "#39405F",
    strokeWidth: 1.31361,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403OopsImage1);
export default __webpack_public_path__ + "static/media/403-Oops-image1.e7a4535341924176a5a4f1b8177a81e4.svg";
export { ForwardRef as ReactComponent };